import { CoverageViewModel } from '@bhtp-client-web/component';

export class Coverage extends CoverageViewModel { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/coverages/coverage.model.ts